import { getTextColorByBackground, formatNumberBR }  from '../../../../utils/stylesUtils'; 

const PxoOciosidadeTable = ({tableData}) => {
    
    const { pxoOciosidadeColumns, pxoOciosidadeRows } = tableData

    const backgroundColor   = tableData.hexColor
    const fontColor         = getTextColorByBackground(backgroundColor)

    const getRowClass = (row) => {
        if (row.rowType === 'grand_total')  return 'bg-[#002A68] text-white font-bold ';
        if (row.rowType === 'bank_total' )  return 'border-b border-green-500 font-bold';
        if (row.rowType === 'yard_total' )  return 'bg-[#7B8C96] font-semibold text-white';
        return '';
    };

    const getCellColor = (value) => {
        
        const num = Number(value);

        if (num < 0)    return "bg-red-100 text-red-800";
        if (num >= 24)  return "bg-green-100 text-green-800";
        if (num < 4.8)  return "bg-yellow-100 text-yellow-800";
        
        return "";
    };

    return (
        <div>
            <table className="shadow-md">

                <thead>
                    <tr
                        style={{ backgroundColor, color: fontColor }}
                    >   
                      
                        {pxoOciosidadeColumns.map((column, index) => (
                            <th key={index}>   
                            
                                <div className="flex flex-col px-2" >
                                    
                                    <span>{column.name}</span>
                                
                                    <span className="font-normal text-[10px]">
                                        {column.timeInDays ? column.timeInDays : <>&nbsp;</>}
                                    </span>

                                </div>
                            </th>
                        ))}
                        
                    </tr>
                </thead>

                <tbody>
                {
                    pxoOciosidadeRows.map((row, j) => {
                        
                        const isTotal = row.isTotalRow;
                        const pxoOciosidadeValues = row.pxoOciosidadeValues ?? [];

                        return (
                            <tr
                                key={j}
                                className={getRowClass(row)}
                            >

                                {pxoOciosidadeValues.map((valueItem, i) => {

                                    const colorClass = !isTotal 
                                        ? getCellColor(valueItem.value) 
                                        : "";

                                    return (
                                        <td 
                                            key={i} 
                                            className={`text-[14px] text-right px-1 ${colorClass} ${isTotal ? "font-bold" : ""}`}
                                        >
                                            {formatNumberBR(valueItem.value)}
                                        </td>
                                    );
                                })}

                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    )

}

export default PxoOciosidadeTable